// turning ai2html's output into a module allows
// webpack to apply hot module replacement.
// we obviously want to bake it into the html in production
// that's why we're conditionally requiring it

import { Child } from 'pym.js';
// import ai2html from './ai2html-graphic.html';
import * as d3 from 'd3';
import meta from './data/meta.json';
import * as hashes from './data/hash-dict';

import Zion from './utils/Zion';

// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)

// utils
import { stylePremium } from './utils/helpers';

// styles
import './styles/graphic.scss';

let latestData;

const mapboxgl = require('mapbox-gl');

const pkg = require('../package.json');

const ai2html = null;

if (process.env.NODE_ENV === 'development') {
  // turning ai2html's output into a module allows
  // webpack to apply hot module replacement.
  // we obviously want to bake it into the html in production
  // that's why we're conditionally requiring it
  // ai2html = require('./ai2html-graphic.html');
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw, id: pkg.name });

console.clear();

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};

const CNNPolitics = false;
const CNNBusiness = false;

stylePremium(CNNPolitics, CNNBusiness);

let chartData;
let rawData;
let lastUpdated;

d3.json('https://ix.cnn.io/data/wssi/toplines.json').then((data) => {
  // New structure: data.three_day_forecast contains the summary
  const forecast = data.three_day_forecast;
  lastUpdated = forecast.updated_str_et;

  rawData = {
    total: {
      area: forecast.total_area_square_miles,
      pct: forecast.total_area_pct_conus,
    },
    byImpact: forecast.by_impact,
    daily: data.daily_forecast,
  };

  d3.select('p#timestamp')
    .html(`Data last updated ${lastUpdated}.`);

  if (pymChild) pymChild.sendHeight();
});

function draw() {
  if (process.env.NODE_ENV === 'development') {
    // the code below applies the ai2html
    // during development mode.


    // If you want to write code for this graphic,
    // move this stuff outside the if block that it's in.
  }
}

d3.timeFormatDefaultLocale({
  periods: ['a.m.', 'p.m.'],
  days: [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ],
  shortDays: ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'],
  months: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  shortMonths: [
    'Jan.',
    'Feb.',
    'March',
    'April',
    'May',
    'June',
    'July',
    'Aug.',
    'Sept.',
    'Oct.',
    'Nov.',
    'Dec.',
  ],
});


mapboxgl.accessToken = 'pk.eyJ1IjoiY25uZGlnaXRhbCIsImEiOiJiYjIwMTgxNDZmNjgyODllMjAxYTYwOTAxYmY2MzI2MyJ9.8F6TQITXymFzCXy8tBqGgg';

const MAP_ID = 'mapbox://styles/cnndigital/clrktauuk001201pv94t1cjvk';


const COLOR_LIMITED = '#FEEDCE';
const COLOR_MINOR = '#F8C153';
const COLOR_MODERATE = '#F18851';
const COLOR_MAJOR = '#C52622';
const COLOR_EXTREME = '#7C4EA5';

document.documentElement.style.setProperty('--color-0', COLOR_LIMITED);
document.documentElement.style.setProperty('--color-1', COLOR_MINOR);
document.documentElement.style.setProperty('--color-2', COLOR_MODERATE);
document.documentElement.style.setProperty('--color-3', COLOR_MAJOR);
document.documentElement.style.setProperty('--color-4', COLOR_EXTREME);

const LAYER_OPACITY = 1;

const state_hashes = hashes.default;
let mapParams;
let hasLocation;
let usingParentDotHtml = false;
let outageEvent;

// check for URL params
function checkParams(events) {
  // use the staging parent URL if we're in the CNN staging environment
  // otherwise use the straight url
  let url;
  if ((pymChild.parentUrl) && (pymChild.parentUrl.indexOf('/parent.html') !== -1)) {
    url = pymChild.parentUrl;
    usingParentDotHtml = true;
  } else {
    url = window.location.href;
  }

  // Parse params
  const getParams = function (url) {
    const params = {};
    const parser = document.createElement('a');
    parser.href = url;
    const query = parser.search.substring(1);
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split('=');
      params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return params;
  };

  const splitMbhash = (text) => {
    let hasharray = [];
    hasharray = text.split('/').map(Number);

    // return the bearing as 0 if it's missing
    if (hasharray.length == 3) {
      hasharray[3] = 0;
    }
    return hasharray;
  };


  mapParams = getParams(url);
  if ('lnglat' in mapParams) {
    mapParams.lnglat = [parseFloat(mapParams.lnglat.split(',')[0]), parseFloat(mapParams.lnglat.split(',')[1])];
  }
  if ('z' in mapParams) {
    mapParams.z = parseFloat(mapParams.z);
  }
  if ('bearing' in mapParams) {
    mapParams.bearing = parseFloat(mapParams.bearing);
  }
  if ('state' in mapParams) {
    mapParams.mbhash = state_hashes[mapParams.state.toUpperCase()];
    console.log('centered on ', mapParams.state.toUpperCase());
  }
  if ('event' in mapParams) {
    const find_event = events.filter(d => d.event_code == mapParams.event);

    if (find_event) {
      outageEvent = find_event[0];
    }

    if (outageEvent && outageEvent.map_view) {
      mapParams.mbhash = outageEvent.map_view;
      console.log('using event', mapParams.event);
    }
  }
  if ('mbhash' in mapParams) {
    const parsedHash = splitMbhash(mapParams.mbhash);
    mapParams.z = parsedHash[0];
    mapParams.lnglat = [parsedHash[2], parsedHash[1]];
    mapParams.bearing = parsedHash[3];
  }

  if (!('scale' in mapParams)) {
    mapParams.scale = 'high';
  }


  // Set params to true if they have what we want (zoom + lng/lat)
  hasLocation = !!('lnglat' in mapParams && 'z' in mapParams);
}


checkParams();

const mapBounds = [
  [-125.000000, 24.396308], // Southwest corner: [longitude, latitude]
  [-66.934570, 49.3457868], // Northeast corner: [longitude, latitude]
];

// screen size config
const optionsSm = {
  initZoom: 2.1,
  minZoom: 2.1,
  maxZoom: 6,
  center: [-95.5, 38.5],
  mapBounds,
};

const optionsLg = {
  initZoom: 3.3,
  minZoom: 3.3,
  maxZoom: 6,
  center: [-97, 38.5],
  mapBounds,
};


const container = d3.select('#graphic');
container.html('');

const mq = window.matchMedia('(min-width: 420px)');

let options;

const updateOptions = (opts, isSmall) => {
  if (mapParams && mapParams.lnglat) {
    opts.center = mapParams.lnglat;
    opts.initZoom = (isSmall) ? mapParams.z - 0.75 : mapParams.z;
  }
  return opts;
};

const handleBrowserSize = () => {
  if (mq.matches) {
    d3.select('#map').attr('style', 'width: 100%; height: 500px;');
    options = optionsLg;
    options = updateOptions(optionsLg, false);
  } else {
    d3.select('#map').attr('style', 'width: 100%; height: 300px;');
    options = optionsSm;
    options = updateOptions(optionsSm, true);
  }
};
handleBrowserSize();


const map = new mapboxgl.Map({
  container: 'map',
  style: MAP_ID,
  center: options.center,
  zoom: options.initZoom,
  maxZoom: options.maxZoom,
  minZoom: options.minZoom,
  bearing: 0,
  scrollZoom: true,
  dragRotate: false,
  logoPosition: 'bottom-right',
  touchPitch: false,
  interactive: true,
  projection: 'albers',
  maxBounds: options.mapBounds,
});

// disable map rotation using right click + drag
map.dragRotate.disable();

// disable map rotation using touch rotation gesture
map.touchZoomRotate.disableRotation();

const nav = new mapboxgl.NavigationControl({
  showCompass: false,
});
map.addControl(nav, 'top-right');


map.on('load', () => {
  // debug: examine layers


  map.addLayer({
    id: 'wssi',
    source: {
      type: 'vector',
      url: 'mapbox://cnndigital.wssi-simple',
    },
    'source-layer': 'Winter Storm Severity Index - 3-Day',
    type: 'fill',
    paint: {
      'fill-color': [
        'match',
        ['get', 'IMPACT'],
        'WINTER WEATHER AREA', COLOR_LIMITED,
        'MINOR', COLOR_MINOR,
        'MODERATE', COLOR_MODERATE,
        'MAJOR', COLOR_MAJOR,
        'EXTREME', COLOR_EXTREME,
        '#fff',
      ],
      'fill-opacity': [
        'match',
        ['get', 'IMPACT'],
        'WINTER WEATHER AREA', LAYER_OPACITY,
        'MINOR', LAYER_OPACITY,
        'MODERATE', LAYER_OPACITY,
        'MAJOR', LAYER_OPACITY,
        'EXTREME', LAYER_OPACITY,
        1,
      ],
    },
  });

  map.moveLayer('wssi', 'jk-albers-us-city-labels-sm');
  map.moveLayer('jk-us-state-labels-v2', 'jk-albers-us-city-labels-sm');
  map.moveLayer('state-innerlines');
});

let prevW = window.innerWidth;
const redraw = () => {
  if (!map || window.innerWidth === prevW) return;
  handleBrowserSize();
  map.setMaxBounds(options.mapBounds);
  map.setMaxZoom(options.maxZoom);
  map.setMinZoom(options.minZoom);
  map.setZoom(options.initZoom);
  map.setCenter(options.center);
  map.resize();
  prevW = window.innerWidth;
};
window.addEventListener('resize', redraw);
